import React, { Component } from 'react'
import FlatButton from 'material-ui/FlatButton'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import Plans from './Plans'
import config from '../../config/config'
import { getCustomer, getPlan } from '../../lib'
import { StripeProvider, Elements } from 'react-stripe-elements';
import Dialog from 'material-ui/Dialog'
import UpdateStripeCard from './Plans/UpdateStripeCard'

class ManagePlans extends Component {
  state = {
    planSwitched: false,
    plan: '',
    card: '',
    errorMessage: '',
    updateCard: false,
    campaign: false
  }

  componentDidMount = async () => {
    const plan = await getPlan()
    this.setState({
      plan: plan
    })

    console.log(plan)
    if (plan == 'premium' || this.props.stripeAccount) {
      try {
        const customer = (await getCustomer()).customer;
        if (customer.sources) {
          this.setState({
            card: customer.sources.data[0],
          })
        }
      } catch (err) {
        console.log(err)
      }
    }

    // TODO: 現在のプランの加入情報を表示する

    // TODO: 現在のクレジットカード情報の番号を取得する

    // TODO: 請求書のリンク情報の取得をする

    // TODO: お問い合わせ情報のリンクを作成する

    // TODO: クレジットでのプランの加入時にローディング画面を表示する

  }

  handleToggle = (e, isToggled) => this.setState({ planSwitched: isToggled })
  onToken = (token) => this.refs.plans.refs.plan.onToken(token)

  handleClose = () => {
    this.setState({ updateCard: false })
  }

  render() {
    const { planSwitched } = this.state
    const starterOneTime = '150,000'
    return (
      <div className="pl2 pt3 h-100" style={{ color: '#6B7C93' }}>
        <Plans
          email={this.props.email}
          userId={this.props.userId}
          campaign={this.props.match.params.campaign === 'campaign'}
          location={this.props.location.pathname}
          stripeAccount={this.props.stripeAccount}
          cancellationDate={this.props.cancellationDate}
          nextInvoiceDate={this.props.nextInvoiceDate}
          failedPaymentDate={this.props.failedPaymentDate}
          failedPaymentCount={this.props.failedPaymentCount}
          changePlan={this.props.changePlan}
          cancelPlan={this.props.cancelPlan}
          createPlan={this.props.createPlan}
          returnUserIfUserExists={this.props.returnUserIfUserExists}
          ref="plans"
          isUpdatingPlan={this.props.isUpdatingPlan}
          planerror={this.props.planerror}
          userPlan={this.state.plan}
          starterPrice={starterOneTime}
          paidUpgrade={this.props.paidUpgrade}
          contract={
            !planSwitched
              ? <FormattedMessage id="mangePlan.month" value="month" />
              : <FormattedMessage id="mangePlan.year" vlaue="year" />
          }
          view={this.props.view}
        />

        <Dialog
          modal
          contentStyle={{ width: '80vw' }}
          open={this.state.updateCard}
          onRequestClose={this.handleClose}>
          <div>
            <StripeProvider apiKey={config.STRIPE_KEY}>
              <Elements>
                <UpdateStripeCard onToken={this.onToken} handleClose={this.handleClose} />
              </Elements>
            </StripeProvider>
          </div>
        </Dialog>

        <div className="flex justify-between mt3 items-center plan-details" style={{width: '50vw'}}>
          {this.props.stripeAccount
            ? <div>
              <FlatButton
                label={<FormattedMessage id="mangePlan.updateCreditCard" />}
                hoverColor="#c59d3f"
                backgroundColor="#f1b62e"
                onClick={() => this.setState({
                  updateCard: true
                })}
                labelStyle={{ color: '#FFFFFF' }}
              />

              <div className="mt3">
                <FormattedMessage id="mangePlan.ccInfo" />: {this.state.card && this.state.card.brand} **** **** ***{this.state.card && this.state.card.last4},
                <FormattedMessage id="mangePlan.expired" /> {this.state.card && this.state.card.exp_month}/{this.state.card && this.state.card.exp_year}
              </div>

              <div className="mt3">
                <Link
                  to={'/admin/invoices'}
                  className="link mt3">
                  <span className="pr2" style={{ fontSize: 18, opacity: 0.37 }}>
                    <FormattedMessage id="mangePlan.paymentHistory" />
                  </span>
                </Link>
              </div>
            </div>
            : <div className="w4" />
          }
        </div>
      </div>
    )
  }
}

export default ManagePlans



// WEBPACK FOOTER //
// src/routes/ManagePlans/ManagePlans.js